import axios from "axios";
import { toast } from 'react-toastify';
import { setIsLoading } from "../reducers/commonSlice";

const ports = {
    login: 3005,
    type: 3010,
    /*     tipo_identificacion: 3010,
        tipo_persona: 3010,
        tipo_propiedad: 3010,
        tipo_proveedor: 3010, */
    user: 3014,
    //medio_pago: 3015,
    module: 3016,
    //auditoria: 3017,
    //user_permission: 3018,
    pay: 3019,
    condo: 3020,
    administrator: 3021,
    //conjunto_administrador: 3022,
    //estado: 3023,
    person: 3024,
    //persona_propiedad: 3025,
    ownership: 3026,
    //conjunto_subscripcion: 3027,
    //conjunto_subscripcion_detalle: 3028,
    //rol_permiso: 3032,
    //permiso_adicional: 3030,
    //permiso_adicional_rol: 3031,
    role: 3032,
    //usuario_conjunto: 3033,
    //usuario_conjunto_rol: 3034,
    //presupuesto: 3035,
    //presupuesto_detalle: 3036,
    //presupuesto_ejecucion: 3037,
    //cuota_administracion: 3038,
    //factura_administracion: 3039,
    //resolucion_facturacion: 3040,
    supplier: 3041,
    task: 3022,
    communication: 3043
}

const getUrl = (endPoint) => {
    const baseUrl = process.env.REACT_APP_BASE_URL || `http://localhost:${ports[endPoint.split('/')[0]]}`;
    return `${baseUrl}/${endPoint}`;
}

export function makeRequest(endPoint, method, data, isMultipart) {
    return new Promise((resolve, reject) => {
        //console.log('request', endPoint, data);
        if (!data)
            data = {};
        if (isMultipart)
            data = { ...data.data }

        if (endPoint.includes('login/')) {
            localStorage.removeItem("loggued_user");
        }

        const userCookie = localStorage.getItem("loggued_user");
        if (!userCookie && !endPoint.includes('login/')) {
            toast('Sesión expirada');
            console.log("no loggued");
        } else {
            let userData = userCookie && JSON.parse(userCookie);

            data.userId = userData?.id;
            data.token = userData?.token;
            if (userData && !userData.isAdmin) {
                if (data.filters) {
                    data.filters.conjunto_id = userData.conjunto_id;
                } else {
                    data.filters = { conjunto_id: userData.conjunto_id }
                }
            }

            if (window.dispatch) {
                window.dispatch(setIsLoading(true));
            }

            axios({ method, url: `${getUrl(endPoint)}`, data, headers: { 'authorization': (userData?.token) || '', "Content-Type": isMultipart ? "multipart/form-data" : "application/json" } })
                .then((response) => {
                    /*  
                    to-do: 
                        -- validar si la respuesta es token vencido y solicitar credenciales nuevamente
                        -- si es un error manejarlo para notificar al usuario
                    */
                    //console.log(response.data);
                    if (response.data.status === 'noUser') {
                        toast('Sesión expirada');
                        showLoginWindow(endPoint, method, data, isMultipart).then(response => {
                            resolve(response);
                        }).catch(err => {
                            reject(err);
                        });

                    } else if (response.data.statusCode === 200) {
                        resolve(response.data.data || response.data);
                    } else
                        resolve(response.data);
                })
                .catch(err => {
                    console.log('====================================');
                    console.log(JSON.stringify(err));
                    console.log('====================================');
                    reject(err);
                })
                .finally(() => {
                    if (window.dispatch) {
                        window.dispatch(setIsLoading(false));
                    }
                });
        }
    });
}

const showLoginWindow = (endPoint, method, data, isMultipart) => {
    return new Promise((resolve, reject) => {
        window.$('#login_modal_form').modal('show');
        window.$('#login_modal_form').on('hidden.bs.modal', function (e) {
            const userCookie = localStorage.getItem("loggued_user");
            let userData = userCookie && JSON.parse(userCookie);
            const newData = { ...data, userId: userData?.id, token: userData?.token };
            makeRequest(endPoint, method, newData, isMultipart).then(response => {
                resolve(response);
            }).catch(err => reject(err))
        })
    })


    /* window.$('#myModal').on('hidden.bs.modal', function (e) {

    }) */
    //loginForm.classList.add("show");
}

export function fixFormData(columnList, formData) {
    let newData = { ...formData };

    columnList.map(x => {
        if (formData[x.dbname]) {
            /*  if (x.type === 'boolean') {
                 if (formData[x.dbname]) {
                     try {
                         newData[x.dbname] = formData[x.dbname][0] === 'on';
                     } catch (ex) {
                         newData[x.dbname] = false;
                     }
                 } else {
                     newData[x.dbname] = false;
                 }
             } */
            if (x.type === 'datetime') {
                newData[x.dbname] = formData[x.dbname].replace('Z', '');
            }
        }
        return {};
    })
    return newData;
}

export async function getFromStorage(id) {
    const dbData = localStorage.getItem(id);
    if (dbData) {
        return JSON.parse(dbData);
    }

    return null;
}

export function deleteFromStorage(id) {
    localStorage.removeItem(id, null);
}

export async function setToStorage(id, value) {
    localStorage.setItem(id, JSON.stringify(value));
}

export const getXY = (e) => {
    let x = 0;
    let y = 0;

    if (
        e.type === "touchstart" ||
        e.type === "touchmove" ||
        e.type === "touchend" ||
        e.type === "touchcancel"
    ) {
        let evt = typeof e.originalEvent === "undefined" ? e : e.originalEvent;
        let touch = evt.touches[0] || evt.changedTouches[0];
        x = touch.pageX; // X Coordinate relative to the viewport of the touch point
        y = touch.pageY; // same for Y
    } else if (
        e.type === "mousedown" ||
        e.type === "mouseup" ||
        e.type === "mousemove" ||
        e.type === "mouseover" ||
        e.type === "mouseout" ||
        e.type === "mouseenter" ||
        e.type === "mouseleave" ||
        e.type === "drag" ||
        e.type === "dragend"
    ) {
        x = e.clientX;
        y = e.clientY;
    }
    return { x, y };
}

export const getBounds = (e) => {
    return { left: e.left, top: e.top, right: e.right, bottom: e.bottom }
}

export const isInBounds = (a, b) => {
    return a.x >= b.left &&
        a.x <= b.right &&
        a.y >= b.top &&
        a.y <= b.bottom
}

export const toSqlDate = (date) => {
    let newDate = date;
    if (date) {
        if (typeof date === "object")
            newDate = date.toISOString();
        return newDate.replace("T", " ").replace("Z", "").split(".")[0];
    }
}

export const timeDifference = (init, endDatetime) => {
    const end = endDatetime || new Date();

}

export const getTimeDetail = (date) => {
    if (!date) return '';
    const date1 = new Date(date);
    const date2 = new Date();
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'Today';//`${date1.getHours()}:${date1.getMinutes()}`;
    if (diffDays === 1) return 'Yesterday';
    return `${diffDays} days ago`;
}

export function whatTypeIsIt(object) {
    console.log('validating:', object);

    const stringConstructor = "test".constructor;
    const arrayConstructor = [].constructor;
    const objectConstructor = ({}).constructor;

    if (!object) {
        return "null";
    }

    if (object.constructor === stringConstructor) {
        console.log('type', "String");

        return "String";
    }
    if (object.constructor === arrayConstructor) {
        console.log('type', "Array");
        return "Array";
    }
    if (object.constructor === objectConstructor) {
        console.log('type', "Object");
        return "Object";
    }
    return "don't know";
}